import React, {Component} from 'react';
import { Trans } from 'react-i18next';

import LayoutMain from '../components/LayoutMain.jsx';
import Row from '../components/Row.jsx';
import IdPDFReuse from '../components/IdPDFReuse.jsx';

class Main extends Component {

  render() {
    const headerMapaPersonalizado = '¡¡Consiga su mapa topográfico personalizado!!'
    const paragraphMapaCarta = 'Mapa a la carta le permite crear un mapa a su medida usando las series impresas del Mapa Topográfico Nacional a escalas 1:25.000 y 1:50.000. Tendrá la posibilidad de definir el área del mismo, incorporar contenidos o personalizar la portada. Podrá obtener un fichero pdf y adquirir copias en papel que recibirá vía postal.';
    const location = this.props.location;
    if(window.mapJs){
      window.mapJs.getPlugins().forEach(p =>{
        if(p.panel_){
          if(p.panel_.name === "panelIGNSearch"){
            p.controls_[0].clearResultsAndGeometry();//Clear old IGNSearch
          }
          if(p.panel_.name === "panelInsertPhoto"){
            window.mapJs.getMapImpl().getLayers().array_.filter(l => l.values_.id && l.values_.id.startsWith("photo-")).forEach(lo => {
              window.mapJs.getMapImpl().removeLayer(lo);//Clear old InsertPhoto Sources
            });
            window.mapJs.getLayers().find(l => {if(l.impl_.name === "insertPhoto"){
                l.removeFeatures(l.getFeatures());//Clear old InsertPhoto Feaatures
                return true;
              }
              return false;
            });
          }
        }
        if(p.panel && p.panel.name === "EditionTools"){
          p.legendCache = undefined;
          p.stylePlugin = null;
        }
      });
      window.mapJs.removeLayers(window.mapJs.getLayers().filter(l => l.layerAddedByEditionTools));//Clear added layers.
    }

    return (<LayoutMain>
      <div className='imageFix'>
      <section className="menu">
        <h1>
        <Trans i18nKey="main.title">
          {headerMapaPersonalizado}
        </Trans>
        </h1>
        <p className="description">
          <Trans i18nKey="main.description">
            {paragraphMapaCarta}
          </Trans>
        </p >
        <p className="description avisoTienda">
        <Trans i18nKey="main.avisoTienda">
        La impresión en soporte rígido se encuentra temporalmente suspendida por obras. Disculpen las molestias.
        </Trans>
        </p >
        <Row location={location}/>
        <IdPDFReuse/>
      </section>
      </div>
    </LayoutMain>);
  }
}

export default Main;
